module.exports = __webpack_public_path__ + "static/media/app-mobile-image.5b5caaab.png";